import React, { useEffect, useState } from "react";
import CampaignMessageStyleStep from "../CampaignMessageStyleStep";
import CustomModal from "@/shared/components/ui/Modal/CustomModal";
import AddCampaignLayout from "../Form/AddCampaignLayout";
import { X } from "lucide-react";

const MessageStyleModal = ({
  isOpen,
  onClose,
  onSave,
  messageStyle = [],
  isSavingMessageStyle,
}) => {
  const [localStyles, setLocalStyles] = useState([]);

  useEffect(() => {
    if (!isOpen) return;
    setLocalStyles(Array.isArray(messageStyle) ? messageStyle : []);
  }, [isOpen, messageStyle]);

  const handleSave = () => {
    if (localStyles.length === 0) return;
    onSave?.(localStyles);
  };

  return (
    <CustomModal isOpen={isOpen} onClose={onClose} width="950px">
      <div className="flex justify-end w-full">
        <button
          type="button"
          className="p-1 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-full transition-colors"
          onClick={onClose}
        >
          <X size={18} className="text-gray-400 dark:text-gray-200" />
        </button>
      </div>
      <AddCampaignLayout
        variant="modal"
        contentClassName="max-h-none overflow-visible px-1"
        title="Choose your messaging styles"
        description="Select up to 1 outreach style for this campaign."
        cancelButtonText="Cancel"
        saveButtonText="Save"
        saveButtonIcon={false}
        onCancel={onClose}
        onSaveAndNext={handleSave}
        isSaving={isSavingMessageStyle}
        children={
          <CampaignMessageStyleStep
            value={localStyles}
            onChange={setLocalStyles}
          />
        }
      />
    </CustomModal>
  );
};

export default MessageStyleModal;
